module.exports = __webpack_public_path__ + "img/wenzi2.8f7d318a.png";